<template>
	<div class="about">
		<div class="top-actions">
			<el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
			<el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>

			<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">添加</el-button>
			<el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>
			<el-button type="success" size="small" @click="handleRunning">运行中</el-button>
			<el-button type="warning" size="small" @click="handlePaused">已暂停</el-button>
			<el-button type="info" size="small" @click="handleCompleted">已完成</el-button>
			<div class="search-container">
				<el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search"
					@input="handleSearch"></el-input>
				<el-button type="default" icon="el-icon-search"
					@click="showSearchFields = !showSearchFields"></el-button>
			</div>
		</div>
		<!-- 添加窗口 -->
		<el-dialog title="添加" :visible.sync="addVisible" width="60%">
			<el-form ref="addForm" :model="addForm" label-width="100px">
				<el-form-item label="任务名">
					<el-input v-model="addForm.keywords" placeholder="随意取一个名字吧"></el-input>
				</el-form-item>
				<el-form-item label="分析源">
					<el-input v-model="addForm.platform" placeholder="输入关键词采集" disabled></el-input>
				</el-form-item>
				<el-form-item label="评论筛选关键词">
					<el-input v-model="addForm.crawlerType" placeholder="评论筛选关键词" disabled></el-input>
				</el-form-item>
				<el-form-item label="消耗点数上限">
					<el-input v-model.number="addForm.dianshu" type="number" min="0" step="1" placeholder="0" style="width: 100px;"></el-input>
					<span>点</span>
				</el-form-item>
				<el-form-item label="搜索排序">
					<el-radio-group v-model="addForm.radio">
						<el-radio :label="3">默认排序</el-radio>
						<el-radio :label="6">最多点赞</el-radio>
						<el-radio :label="9">最新发布</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="视频发布时间">
					<el-radio-group v-model="addForm.videotime">
						<el-radio :label="3">默认</el-radio>
						<el-radio :label="6">3天内</el-radio>
						<el-radio :label="9">一周内</el-radio>
						<el-radio :label="12">15天内</el-radio>
						<el-radio :label="15">一个月内</el-radio>
						<el-radio :label="18">半年内</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="定时监控频率">
					<span>每</span>
					<el-input v-model="addForm.day" placeholder="0" style="width: 100px;"></el-input>
					<span>天 运行一次</span>
				</el-form-item>
				<el-form-item label="最长监控天数">
					<span>持续监控</span>
					<el-input v-model="addForm.keep" placeholder="0" style="width: 100px;"></el-input>
					<span>天 后停止</span>
				</el-form-item>


			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveAdd">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 搜索参数 -->

		<div v-if="showSearchFields" class="advanced-search-fields">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form :model="searchForm" label-width="100px">
						<el-form-item label="任务ID">
							<el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
						</el-form-item>
						<el-form-item label="任务名">
							<el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="12">
					<el-form :model="searchForm" label-width="100px">
						<el-form-item label="采集源">
							<el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
						</el-form-item>
						<el-form-item label="创建时间">
							<el-input v-model="searchForm.creationTime" placeholder="请输入创建时间"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<el-button type="default" @click="handleAdvancedSearch">提交</el-button>
		</div>

		<el-table ref="filterTable" :data="filteredTableData"
			:header-cell-style="{ color: '#606266', background: '#f5f7fa' }" style="width: 100%" stripe border
			@selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="taskId" label="任务id" sortable width="180" column-key="date"
				:filters="[{ text: '2016-05-01', value: '2016-05-01' }, { text: '2016-05-02', value: '2016-05-02' }, { text: '2016-05-03', value: '2016-05-03' }, { text: '2016-05-04', value: '2016-05-04' }]"
				:filter-method="filterHandler"></el-table-column>
			<el-table-column prop="keywords" label="任务名" width="180"></el-table-column>
			<el-table-column prop="collectionSource" label="采集源" ></el-table-column>
			<el-table-column prop="status" label="任务状态" ></el-table-column>
			<el-table-column prop="commentCount" label="意向客户数" >
				<template slot-scope="scope"><el-link type="primary" style="color: #409EFF; cursor: pointer; font-weight: 600;" @click="openTaskData(scope.row, 'comment')">{{ scope.row.commentCount }}</el-link></template>
			</el-table-column>
			<el-table-column prop="videoCount" label="线索视频数" >
				<template slot-scope="scope"><el-link type="primary" style="color: #409EFF; cursor: pointer; font-weight: 600;" @click="openTaskData(scope.row, 'video')">{{ scope.row.videoCount }}</el-link></template>
			</el-table-column>
			<el-table-column prop="consumedPoints" label="今日消耗"></el-table-column>
			<el-table-column prop="address" label="定时截止" ></el-table-column>
			<el-table-column prop="creationTime" label="创建时间" ></el-table-column>
			<!-- 其他列根据需要添加 -->
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="handleStart(scope.$index, scope.row)">开始任务</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
					
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" :current-page="currentPage" :page-size="pgSize"
				:total="filteredTableData.length" @current-change="handlePageChange"></el-pagination>
		</div>
		
	</div>

</template>

<script>
// 在组件顶部导入 dy_create_task
import { dy_create_task ,create_task,start_crawler} from '@/api/douyin';
import { getDashboardSummary } from '@/api/statistics';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver'; 

export default {
	data() {
		return {
			currentPage: 1,
			pgSize: 4,
			idx: -1,
			editVisible: false,
			form: {},
			searchQuery: '',
			showSearchFields: false,
		
			searchForm: {
				taskId: '',
				taskName: '',
				collectionSource: '',
				dianshui: '',
				radio: 3,

				creationTime: '',
				radio: 3,
				videotime: '',
				day: '',
				keep: '',
			},
			selectedRows: [],
			tableData: [
				// 这里是表格数据
			],
			addVisible: false, // 控制添加对话框的显示

			addForm: {
            platform: 'xhs',
            crawler_type: 'search',
            keywords: '',
            dianshu: 0
         }
		}
	},
	computed: {
		filteredTableData() {
			return this.tableData.filter(data => {
				return Object.values(data).some(value => {
					return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
				});
			});
		}
	},
	created() {
        this.fetchData();
    },
	methods: {
		openTaskData(row, type) {
			const path = type === 'comment' ? '/xhs_note_comments' : '/xhs_note';
			this.$router.push({ path, query: { task_id: row.taskId, order_date: row.orderDate || '', order_amount: row.orderAmount || '' } });
		},
		
		fetchData() {
			dy_create_task().then(response => {
           
			const taskRows = Array.isArray(response.data)
				? response.data
				: (response.data?.data || [])
			this.tableData = taskRows.map(item => ({
                taskId: item.id,
				keywords: item.keywords, 
                collectionSource: item.platform, 
                status: { pending: '待执行', running: '运行中', completed: '已完成', failed: '失败', cancelled: '已取消' }[item.status] || item.status, 
                title: item.status, 
                count: 0, // 默认值,因为后端未返回此字段
                cmonet: 0, // 默认值,因为后端未返回此字段
                creationTime: item.created_at,
                orderDate: item.order_date,
                orderAmount: item.order_amount,
                commentCount: item.comment_count || 0,
                videoCount: item.video_count || 0,
                consumedPoints: item.comment_count || 0,
                commentLimit: item.comment_limit || 0,
                
            }));
        }).catch(error => {
            console.error('获取数据时出错！', error);
            this.$message.error('获取任务列表失败');
        });
        },
		// 调用 getTaskList
		handleRefresh() {
			this.fetchData();
		},
		handleAdd() {
			this.addVisible = true;
		},

		// 调用 deleteTask
		handleDelete(index, row) {
			this.$confirm('确定要删除吗？', '提示', {
				type: 'warning'
			}).then(() => {
				this.deleteTask(row.taskId);
			}).catch(() => { });
		},

		// 批量删除
		handleDeleteSelected() {
			this.selectedRows.forEach(row => {
				this.deleteTask(row.taskId);
			});
		},
		handleRunning() {
			// 运行中任务的逻辑
		},
		handlePaused() {
			// 已暂停任务的逻辑
		},
		handleCompleted() {
			// 已完成任务的逻辑
		},
		
		// 调用 updateTask
		
		handleDelete(index, row) {
			this.$confirm('确定要删除吗？', '提示', {
				type: 'warning'
			}).then(() => {
				this.$message.success('删除成功');
				this.tableData.splice(index, 1);
			}).catch(() => { });
		},
		handlePageChange(val) {
			this.currentPage = val;
		},
		handleSelectionChange(selection) {
			this.selectedRows = selection;
		},
		resetDateFilter() {
			this.$refs.filterTable.clearFilter('date');
		},
		clearFilter() {
			this.$refs.filterTable.clearFilter();
		},
		formatter(row, column) {
			return row.address;
		},
		filterTag(value, row) {
			return row.tag === value;
		},
		filterHandler(value, row, column) {
			const property = column['property'];
			return row[property] === value;
		},
		handleSearch() {
			// 这个方法在搜索框输入变化时触发
		},
		handleAdvancedSearch() {
			// Logic to perform advanced search using searchForm data
			console.log('Advanced search:', this.searchForm);
			this.showSearchFields = false;
		},

  resetAddForm() {
    this.addForm = {
      taskId: '',
      taskName: '',
      collectionSource: '',
      dianshu: '',
      radio: 3,
      videotime: 3,
      day: '',
      keep: ''
    };
    this.addVisible = false;
  },

	// 调用 post
	async saveAdd() {
		try {
			const { data } = await getDashboardSummary();
			if (Number(data.remaining_points || 0) <= 0) {
				this.$message.error('点数已经用完');
				return;
			}
		} catch (error) {
			this.$message.error(error.response?.data?.detail || '获取点数余额失败');
			return;
		}
		const payload = {
      "platform":"xhs" ,
      "crawler_type":"search" ,
      "keywords": this.addForm.keywords,
      "comment_limit": Number(this.addForm.dianshu || 0)
    };
    console.log('Payload:', payload); // 调试输出
      create_task(payload)
        .then(response => {
          if (response.status === 200) {
            this.$message.success('任务添加成功');
            // this.tableData.push({
            //   taskId: response.data.id,
            //   taskName: response.data.keywords,
            //   collectionSource: response.data.platform,
            //   status: response.data.status,
            //   creationTime: response.data.created_at,
            // });
            this.resetAddForm();
          } else {
            this.$message.error('任务添加失败');
          }
        })
        .catch(error => {
          this.$message.error(error.response?.data?.detail || error.response?.data?.error || '请求出错，请稍后再试');
          console.error(error);
        });
    },

	async handleStart(index, row) {

	const keywords = row.keywords.trim(); // 从表格行中获取并修剪关键词
   if (!keywords) {
    this.$message.error('关键词不能为空，请选择一个有关键词的任务');
    return; // 如果关键词为空，提前返回，不执行后续逻辑
   }
		try {
			const { data } = await getDashboardSummary();
			if (Number(data.remaining_points || 0) <= 0) {
				this.$message.error('点数已经用完');
				return;
			}
		} catch (error) {
			this.$message.error(error.response?.data?.detail || '获取点数余额失败');
			return;
		}
	        console.log('开始任务，任务ID为：', row.taskId);
		this.$message({
        message: '开始任务中，任务ID为：' + row.taskId+',请等待十分钟左右任务完成',
        type: 'info'
    });

	const payload = {
     // 添加任务ID到payload
      platform: "xhs",
      crawler_type: "search",
      keywords: keywords,
      task_id: Number(row.taskId || 0)
    };
        // 假设调用一个名为 startTask 的函数来向后端发送开始任务的请求
        start_crawler(payload)
           .then(response => {
                if (response.status === 200) {
                    const result = response.data?.result || {};
                    const nextStatus = result.status === 'empty' ? '无数据' : '运行中';
                    this.$message({
                        message: response.data?.message || '任务已开始',
                        type: result.status === 'empty' ? 'warning' : 'success'
                    });
                    this.tableData = this.tableData.map(item => {
                      if (item.taskId === row.taskId) {
                        return { ...item, status: nextStatus };
                      }
                      return item;
                    });
                } else {
                    this.$message.error('任务开始失败');
                }
            })
           .catch(error => {
                const errorMessage = error.response?.data?.detail || error.response?.data?.message || '请求出错，请稍后再试';
                this.$message.error(errorMessage);
                this.tableData = this.tableData.map(item => {
                  if (item.taskId === row.taskId) {
                    return { ...item, status: '执行失败' };
                  }
                  return item;
                });
                console.error(error);
            });

    }

		

		// 删除任务的 DELETE 请求方法
		// async deleteTask(taskId) {
		// 	try {
		// 		const response = await DeleteTask({ taskId });
		// 		if (response.status === 200) {
		// 			this.$message.success('任务删除成功');
		// 			this.tableData = this.tableData.filter(row => row.taskId !== taskId);
		// 		} else {
		// 			this.$message.error('任务删除失败');
		// 		}
		// 	} catch (error) {
		// 		this.$message.error('请求出错，请稍后再试');
		// 		console.error(error);
		// 	}
		// },

	}
}
</script>

<style lang="stylus">
  .top-actions
   display flex
   align-items center
   justify-content space-between
   margin-bottom 10px

  .search-container
   margin-left: auto
  
  .button-container
   margin-right: auto

  .advanced-search-fields {
	margin-bottom: 10px;
  }
  
  
  
  </style>
